import { HealthMetrics } from '../types/health';

export interface WorkoutRecommendation {
  name: string;
  type: string;
  duration: number;
  targetStrain: number;
  intensity: 'Light' | 'Moderate' | 'High' | 'Peak';
  description: string;
  benefits: string[];
  suitable: boolean;
  reason?: string;
}

export function getWorkoutRecommendations(metrics: HealthMetrics): WorkoutRecommendation[] {
  const { recovery, strain, readiness } = metrics;
  
  const recommendations: WorkoutRecommendation[] = [
    {
      name: 'HIIT Cardio',
      type: 'hiit',
      duration: 45,
      targetStrain: 14.5,
      intensity: 'High',
      description: 'High-intensity interval training for maximum results',
      benefits: ['Improves cardiovascular fitness', 'Burns calories efficiently', 'Boosts metabolism'],
      suitable: recovery > 80 && strain.current < 12
    },
    {
      name: 'Strength Training',
      type: 'strength',
      duration: 60,
      targetStrain: 12.0,
      intensity: 'Moderate',
      description: 'Full-body strength workout with progressive overload',
      benefits: ['Builds muscle', 'Increases strength', 'Improves bone density'],
      suitable: recovery > 70 && strain.current < 14
    },
    {
      name: 'Recovery Flow',
      type: 'recovery',
      duration: 30,
      targetStrain: 6.0,
      intensity: 'Light',
      description: 'Active recovery session with mobility work',
      benefits: ['Enhances recovery', 'Improves flexibility', 'Reduces muscle tension'],
      suitable: recovery < 70 || strain.current > 16
    }
  ];

  // Add suitability reasons
  return recommendations.map(rec => ({
    ...rec,
    reason: !rec.suitable
      ? `Recovery (${recovery}%) or current strain (${strain.current}) not optimal`
      : undefined
  }));
}